import React from 'react'
import {FullHeightCalculator} from '../'

class ProductHero extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { className } = this.props;

    return (
      <div className={"ProductHero" + (className ? " " + className : "")}>
        <FullHeightCalculator heightAdjust={-100}>

        </FullHeightCalculator>
      </div>
    )
  }

}

export default ProductHero;



// WEBPACK FOOTER //
// ./src/components/marketing/ProductHero.js